import { render, staticRenderFns } from "./NonBondedBulkUpload.vue?vue&type=template&id=036ce540"
import script from "./NonBondedBulkUpload.vue?vue&type=script&lang=js"
export * from "./NonBondedBulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports